export default {
  shop: null,
  shopUser: null,
  pricingPercent: 0
}
